import React from "react";
import { Images } from "../helper/images";
import { NavLink } from "react-router-dom";

const Header = () => {
  return (
    <header
      className="dahboardheader bg-white border-bottom px-3 py-2 d-flex align-items-center justify-content-between">
      <NavLink to={'/'}>
        <img src={Images.incorpLogo} alt="Logo" />
      </NavLink>
      <img src={Images.navigatorLogo} alt="Logo" />
    </header>
  );
};

export default Header;
